import React, { Component, PropTypes } from 'react'
import { translate } from 'react-i18next'
import R from 'ramda'
import styled from 'styled-components'
import AdminNavbar from '../../components/AdminNavbar'
import CardContainer from '../../components/CardContainer'
import ThemeContainer from '../../components/ThemeContainer'
import {
  updateCategory,
  deleteCategory,
  createCategory
} from '../../sources/AdminSource'
import { searchCategories } from '../../sources/SearchSource'
import { categoryDefault } from '../../Utils/Defaults'
import Input from '../../components/Input'
import { Metrics, Fonts } from '../../Themes'
import Button from '../../components/Button'
import BackArrow from '../../svg-icons/BackArrow'
import ErrorModal from '../../components/Modal/ErrorModal'
import SuccessModal from '../../components/Modal/SuccessModal'
import DialogModal from '../../components/Modal/DialogModal'

const Container = styled.div`
  max-height: ${Metrics.components.adminContent};
  overflow-y: scroll;
`

const CustomCardContainer = styled(CardContainer)`
  margin-top: ${Metrics.margins.base};

  button {
    margin-top: ${Metrics.margins.base};
    float: right;
  }
`

const ArrowContainer = styled.div`
  margin-top: ${Metrics.margins.base};
  margin-bottom: ${Metrics.margins.base};
  cursor: pointer;

  span {
    padding-left: ${Metrics.margins.medium};
    ${Fonts.style.Header};
  }
`

const CustomThemeContainer = styled(ThemeContainer)`
  padding-left: ${Metrics.components.customThemeSpacing} !important;
  padding-right: ${Metrics.components.customThemeSpacing} !important;
`

const ButtonContainer = styled.div`height: 50px;`

class EditCategory extends Component {
  constructor (props) {
    super(props)
    this.state = {
      create: false,
      category: R.clone(categoryDefault),
      modal: false
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.openDeleteModal = this.openDeleteModal.bind(this)
  }

  componentWillMount () {
    const { params } = this.props
    if (params.id !== 'new') {
      searchCategories({ id: params.id })
        .then(response => this.setState({ category: response.data }))
        .catch(error => console.log(error))
    } else {
      this.setState({ create: true })
    }
  }

  handleChange (event) {
    const { category } = this.state
    category.name = event.target.value
    this.setState({ category })
  }

  handleSubmit () {
    const { category, create } = this.state

    if (create) {
      createCategory(category.name)
        .then(response =>
          this.setState({
            modal: 'success',
            category: R.clone(categoryDefault)
          })
        )
        .catch(error => {
          console.log(error)
          this.setState({ modal: 'error' })
        })
    } else {
      updateCategory(category)
        .then(response => this.setState({ modal: 'success' }))
        .catch(error => {
          console.log(error)
          this.setState({ modal: 'error' })
        })
    }
  }

  handleDelete () {
    const { router } = this.props
    deleteCategory(this.state.category.id)
      .then(response => router.goBack())
      .catch(error => {
        console.log(error)
        this.setState({ modal: 'error' })
      })
  }

  openDeleteModal () {
    this.setState({ modal: 'dialog' })
  }

  closeModal () {
    this.setState({ modal: false })
  }

  render () {
    const { t, router, admin, dropdownLinks } = this.props
    const { category, modal, create } = this.state
    return (
      <div>
        <AdminNavbar
          admin={admin}
          fixedSearchBar
          dropdownLinks={dropdownLinks}
          rightSideActions={
            create ? (
              []
            ) : (
              [
                {
                  label: t('Delete Category'),
                  secondary: true,
                  onClick: this.openDeleteModal
                }
              ]
            )
          }
        />
        <ErrorModal
          visible={modal === 'error'}
          message={t(
            `There was an error on ${create
              ? 'creating'
              : 'updating'} the category`
          )}
          closeAction={this.closeModal}
          header={t('Error')}
        />
        <SuccessModal
          visible={modal === 'success'}
          message={t(
            `The category was successfully ${create ? 'created' : 'updated'}`
          )}
          closeAction={this.closeModal}
          header={t('Category Updated')}
        />
        <DialogModal
          visible={modal === 'dialog'}
          message={t('Do you really want to delete the category?')}
          closeAction={this.closeModal}
          header={t('Delete Category')}
          buttons={{
            apply: { label: t('Delete'), onClick: this.handleDelete },
            cancel: { label: t('Cancel'), onClick: this.closeModal }
          }}
        />
        <Container>
          <CustomThemeContainer>
            <ArrowContainer onClick={() => router.goBack()}>
              <BackArrow />
              <span>{create ? t('Insert Category') : category.name}</span>
            </ArrowContainer>
            <CustomCardContainer
              title={create ? t('New Category') : t('Edit Category')}>
              <Input
                handleChange={this.handleChange}
                title={t('Category Name')}
                value={category.name}
              />
              <ButtonContainer>
                <Button
                  onClick={this.handleSubmit}
                  label={create ? t('Add') : t('Save')}
                />
              </ButtonContainer>
            </CustomCardContainer>
          </CustomThemeContainer>
        </Container>
      </div>
    )
  }
}

EditCategory.propTypes = {
  t: PropTypes.func,
  router: PropTypes.object,
  params: PropTypes.object,
  admin: PropTypes.object,
  dropdownLinks: PropTypes.array
}

export default translate([ 'common', 'admin' ], { wait: true })(EditCategory)



// WEBPACK FOOTER //
// ./src/pages/AdminCategories/EditCategory.js